import React,{useState} from 'react';

import Expenses from './Components/Expenses';
import NewExpense from './Components/NewExpense/NewExpense';

let Dummy_expense = [
    
];
const App=()=>{
    
    const [expenses, setExpense]=useState(Dummy_expense);
    const addExpenseHandler=(expense)=>
    {
        const updateExpense=[expense, ...expenses];
        setExpense(updateExpense);
        
        
    };
    
    return ( <div>
             <NewExpense onaddExpense={addExpenseHandler}/>
             <Expenses item={expenses}/>
             </div>
    );
}

export default App;